export default () =>
  <svg width="22px" height="20px" viewBox="0 0 22 20" className="cmr c-voter-heart">
    <path d="M11,20 L9.40478846,18.5827604 C3.73989423,13.4605208 0,10.1359375 0,5.99453125 C0,2.61567708 2.63989423,0 6.05,0 C7.97494712,0 9.78984135,0.871979167 11,2.28890625 C12.2101058,0.871979167 14.0249471,0 15.95,0 C19.3601058,0 22,2.61567708 22,5.99453125 C22,10.1359896 18.2600529,13.4605729 12.5952115,18.5827604 L11,20 Z" fillRule="nonzero"></path>
  </svg>
